export default "__VITE_ASSET__583e0eee__"